export default "__VITE_ASSET__CmxQ8XRe__"